import * as Yup from 'yup';
import { useState, useEffect, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';


// material
import { Stack, TextField, Alert} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, editarMesa, visualizarMesa} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';


// ----------------------------------------------------------------------

export default function EditarDespesaForm() {

  const {id} = useParams();
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    codigo_mesa: Yup.string().required('Código da Mesa é obrigatório'),
    descricao: Yup.string().min(2, 'Muito Pequeno!').max(500, 'Muito Longo!').required('Descrição é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
        codigo_mesa: '',
        descricao: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();
    const response = await editarMesa(id, formik.values);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    };
  }

  const { errors, touched, isSubmitting, getFieldProps, setFieldValue} = formik;

  useEffect(() => {
    const getMesas = async () => {
      const retorno = await reiniciarToken();
      if(retorno.erro === true) {
        if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
          logout();
        }
      }else{
        localStorage.setItem("token", retorno.data.token);
        api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
      }
      
      const response = await visualizarMesa(id);
      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }else {
          setStatus({
            type: "erro",
            mensagem: response.mensagem
          })
        }
      };

      const campos = ['codigo_mesa','descricao'];

      campos.forEach((campo) => {
        setFieldValue(campo, response.data[0][campo], false);
      })
    }

    getMesas();

  } , [setFieldValue, id]);
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Código Mesa"
              {...getFieldProps('codigo_mesa')}
              error={Boolean(touched.codigo_mesa && errors.codigo_mesa)}
              helperText={touched.codigo_mesa && errors.codigo_mesa}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Descrição"
              {...getFieldProps('descricao')}
              error={Boolean(touched.descricao && errors.descricao)}
              helperText={touched.descricao && errors.descricao}
            />
          </Stack>
          
          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Alterar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
